import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Lightbulb, Palette, Sun } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function LightingPreviewSection() {
  const navigate = useNavigate();

  const handleNavigateToSmartHome = () => {
    navigate("/smarthome#lighting");
  };

  const handleNavigateToElektra = () => {
    navigate("/elektra");
  };

  return (
    <section className="py-16 bg-gradient-to-b from-muted/20 to-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Lightbulb className="h-8 w-8 text-primary" />
            <h2 className="text-3xl font-bold">Intelligente LED Verlichting</h2>
          </div>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            RGBW LED spots en plafondverlichting met 16 miljoen kleuren en automatische sturing
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="aspect-video bg-muted">
              <video 
                className="w-full h-full object-cover"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="https://pim.loxone.com//01%20Product%20Data/01%20Products/Lighting/100334%20-%20LED%20Spot%20RGBW%20Tree%20Anthrazit/Images/vi-overview-100334-led-spot-rgbw-tree-anthrazit.webm" type="video/webm" />
                Video niet ondersteund
              </video>
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">LED Spot RGBW Tree Antraciet</h3>
              <p className="text-muted-foreground text-sm">
                Inbouwspots met 16 miljoen kleuren in antraciet, perfect voor moderne interieurs
              </p>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="aspect-video bg-muted">
              <video 
                className="w-full h-full object-cover"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="https://pim.loxone.com//01%20Product%20Data/01%20Products/Lighting/100330%20-%20LED%20Spot%20RGBW%20Tree%20Wei%C3%9F/Images/vi-overview-100330-led-spot-rgbw-tree-white.webm" type="video/webm" />
                Video niet ondersteund
              </video>
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">LED Spot RGBW Tree Wit</h3>
              <p className="text-muted-foreground text-sm">
                Inbouwspots met 16 miljoen kleuren in wit, elegant en tijdloos design
              </p>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="aspect-video bg-muted">
              <video 
                className="w-full h-full object-cover"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="https://pim.loxone.com//01%20Product%20Data/01%20Products/Lighting/100287%20-%20LED%20Ceiling%20Light%20RGBW%20Air%20Anthrazit/Images/vi-overview-100287-ceiling-light-air-anthrazit.webm" type="video/webm" />
                Video niet ondersteund
              </video>
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">LED Plafondlamp RGBW Air</h3>
              <p className="text-muted-foreground text-sm">
                Elegante plafondverlichting met RGBW technologie voor optimale lichtbeleving
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={handleNavigateToElektra} size="lg" className="px-8">
            LED Verlichting Diensten
          </Button>
          <Button onClick={handleNavigateToSmartHome} variant="outline" size="lg" className="px-8">
            Verlichting in Smart Home
          </Button>
        </div>
      </div>
    </section>
  );
}